var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-left"
  }, [_vm.gatewayData ? _c('span', [_vm._v(" " + _vm._s(_vm.gatewayData.label) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.gateway) + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }